import React from 'react';

export function EllipsisVerticalIcon() {
  // https://lucide.dev/icons/ellipsis-vertical
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="19" r="1" />
    </g>
  );
}
